import{jsxs as o,jsx as t}from"react/jsx-runtime";import e from"styled-components";import r from"../../../../assets/images/whatsAppBackground.jpg.js";import{useConversationBottomScroll as i}from"../../../../hooks/useConversationBottomScroll.js";import{withTranslations as n}from"../../../../services/translations/withTranslations.js";import{BottomBar as s}from"./BottomBar.js";import{TopBar as m}from"./TopBar.js";import{HelveticaFontStyle as a}from"../../../../style/fonts/helveticaFontStyle.js";const p=e.div`
  box-sizing: content-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-end;
  background: #efe7dd url(${r}) repeat;
`,d=e.div`
  ${a}
  padding: 5px 16px;
  height: 100%;
  position: relative;
  z-index: 0;
  overflow: auto;
`,l=n((({children:e,extendedFrame:r=!0})=>{const n=i(e);return o(p,{extendedFrame:r,children:[r&&t(m,{}),t(d,{ref:n,children:e}),r&&t(s,{})]})}));export{l as AppFrameWhatsApp};
//# sourceMappingURL=AppFrameWhatsApp.js.map
